import { StowageWrapper, ExtraButtonMenu, MenuItemButton } from '../PageHeader.styles';
import { useAuthStore } from '../../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStowageStore } from 'src/context/StowageContext';
import { Separator } from 'src/App.styles';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { getValueOrMax } from 'src/utils/stowage/stowageOperation/rotationCallStatusesUtils';
import { useEffect, useRef, useState } from 'react';
import { DropdownIcon, DropDownOptionsList, DropDownWrapper } from 'src/styles/dropDown.style';
import { stowageFeatureEnum } from 'src/enums/stowage/stowageFeatureEnum';
import { hasPermission } from 'src/utils/stowage/permissions/stowagePermissionsUtils';
import PageHeaderStowageCopy from './PageHeaderStowageCopy';
import useStowageQueryParamsUtils from 'src/utils/stowage/useStowageQueryParamsUtils';
import PageHeaderStowageRename from './PageHeaderStowageRename';
import { getNumberOfOpenSyncChanges } from 'src/utils/stowage/stowagePlanComparison/compareRotationUtilsV2';
import { getMasterStowagePlan, getNonMastertowagePlans, getStowagePlanType } from 'src/utils/stowage/stowagePlanUtils';
import PageHeaderContextMenu from './pageHeaderContextMenu/PageHeaderContextMenu';
import PageHeaderStowagePublishPromoteButton from './pageHeaderStowagePublishPromoteButton/PageHeaderStowagePublishPromoteButton';
import PageHeaderStowagePlanItem from './PageHeaderStowagePlanItem';
import PageHeaderStowagePlanListItem from './PageHeaderStowagePlanListItem';
import PageHeaderStowagePlanListGroup from './PageHeaderStowagePlanListGroup';
import PageHeaderStowagePrintPanel from './PageHeaderStowagePrintPanel';
import { RedIcon } from 'src/components/ui/status-icon/VerificationIcon.styles';
import { IconsWrapper, InvalidTankplan } from 'src/components/stowage/tankPlanView/TankPlanMenus/TankPlanTopMenu.styles';
import ViolationListIconComponent from 'src/components/stowage/violationListView/ViolationListIcon';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { useViolationsStore } from 'src/context/ViolationsContext';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { useVesselStore } from 'src/context/VesselContext';
import { StowageRuleViolationStatus } from 'src/enums/stowage/stowageRule/stowageRuleViolationStatus';

const PageHeaderStowageComponent = () => {
    const [showInvalidStowagePlan, setShowInvalidStowagePlan] = useState<boolean | null>(false);
    const {
        isStowagePlanListMenuOpen,
        setIsStowagePlanListMenuOpen,
        triggerChangeLogProps,
        setTriggerChangeLogProps,
        isUtilizationOpen,
        setIsUtilizationOpen,
        stowagePlans,
        activeStowagePlan,
        isCopyStowagePlanMenuOpen,
        setIsCopyStowagePlanMenuOpen,
        isRenameStowagePlanMenuOpen,
        imosSyncChanges,
        setActiveStowagePlan,
        isPrintPanelOpen,
        setIsPrintPanelOpen,
        hasClosedOldStowagePlanModal,
        setHasClosedOldStowagePlanModal,
    } = useStowageStore();
    const { role, loggedInUser } = useAuthStore();
    const { setQueryParamStowagePlan } = useStowageQueryParamsUtils();
    const { violations, isStowagePlanValid } = useViolationsStore();
    const { setSelectedTab, setSelectedViolationListFilter } = useStowageSelectionStore();
    const { selectedVessel } = useVesselStore();
    const masterPlanRef = useRef(null);
    const { setMouseClickPosition } = useStowageStore();

    useEffect(() => {
        const checkIfClickedOutside = (event) => {
            if (isStowagePlanListMenuOpen && masterPlanRef.current && !masterPlanRef.current.contains(event.target)) {
                setIsStowagePlanListMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', checkIfClickedOutside);

        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [isStowagePlanListMenuOpen]);

    useEffect(() => {
        if (selectedVessel) {
            setIsPrintPanelOpen(false);
        }
    }, [selectedVessel]);

    useEffect(() => {
        if (isStowagePlanValid !== null && isStowagePlanValid === true) {
            setShowInvalidStowagePlan(false);
        } else if (isStowagePlanValid !== null && isStowagePlanValid === false) {
            setShowInvalidStowagePlan(true);
        }
    }, [isStowagePlanValid]);

    const onOpenMasterPlanMenu = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setIsCopyStowagePlanMenuOpen(false);
        if (!isStowagePlanListMenuOpen) setIsStowagePlanListMenuOpen(true);
    };

    const onOpenChangeLog = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        if (imosSyncChanges.length > 0) {
            setTriggerChangeLogProps(
                triggerChangeLogProps?.isChangeLogOpen
                    ? null
                    : {
                          isChangeLogOpen: true,
                          stowagePlanSyncChanges: imosSyncChanges,
                          shouldFilterClosedOrCompletedVoyages: true,
                          title: 'Updates from IMOS',
                          syncedDateTimeField: 'syncedWithImosDateTimeUtc',
                          shouldAddChanges: true,
                      }
            );
            setIsUtilizationOpen(false);
        }
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
    };

    const onOpenUtilization = (e: any) => {
        setIsUtilizationOpen(!isUtilizationOpen);
        setTriggerChangeLogProps(null);
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
    };

    const onOpenPrintPanel = (e: any) => {
        setIsUtilizationOpen(false);
        setTriggerChangeLogProps(null);
        setIsStowagePlanListMenuOpen(false);

        setIsPrintPanelOpen(!isPrintPanelOpen);
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
    };

    const switchStowagePlan = (ev: any, stowagePlan: StowagePlan) => {
        ev.stopPropagation();

        const _stowagePlans = stowagePlans;
        if (!_stowagePlans || _stowagePlans.length === 0) {
            return;
        }

        setActiveStowagePlan(null);
        setIsStowagePlanListMenuOpen(false);
        if (hasClosedOldStowagePlanModal) setHasClosedOldStowagePlanModal(false);
        setQueryParamStowagePlan(stowagePlan.stowagePlanGuid);
    };

    const getStowagePlanTypeTitle = (stowagePlanType: string) => {
        const titles = {
            master: 'Master plan',
            published: 'Published plan',
            shared: 'Shared plan',
            draft: 'Draft plan',
        };

        return titles[stowagePlanType];
    };

    const onViewHardRuleViolations = (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        setSelectedTab('Violation List');
        setSelectedViolationListFilter('All');
    };
    const numberOfOpenImosSyncChanges = getNumberOfOpenSyncChanges(imosSyncChanges);

    const hasHardRuleViolations = () => {
        return violations && violations.length > 0 && violations.some((violation) => violation.type === StowageRuleConsequenceType.HardRule);
    };

    const hasSoftRuleViolations = () => {
        return (
            violations &&
            violations.length > 0 &&
            violations.some(
                (violation) => violation.type === StowageRuleConsequenceType.SoftRule && violation.status !== StowageRuleViolationStatus.Accepted
            )
        );
    };

    const shouldShowInvalidStowagePlan = () => {
        return showInvalidStowagePlan && hasHardRuleViolations();
    };

    const shouldShowViolations = () => {
        return hasHardRuleViolations() || hasSoftRuleViolations();
    };

    return (
        role &&
        hasPermission(role, stowageFeatureEnum.ViewStowagePlan) && (
            <>
                <StowageWrapper>
                    {isRenameStowagePlanMenuOpen && <PageHeaderStowageRename />}
                    {isCopyStowagePlanMenuOpen && <PageHeaderStowageCopy />}
                    {isPrintPanelOpen && <PageHeaderStowagePrintPanel onClose={() => setIsPrintPanelOpen(false)} />}
                    <DropDownWrapper width="400px" justify_content="left" onClick={(e) => onOpenMasterPlanMenu(e)}>
                        {activeStowagePlan && stowagePlans && (
                            <span className="heading" title={getStowagePlanTypeTitle(getStowagePlanType(activeStowagePlan))}>
                                <PageHeaderStowagePlanItem stowagePlan={activeStowagePlan} stowagePlanType={getStowagePlanType(activeStowagePlan)} />
                            </span>
                        )}

                        {isStowagePlanListMenuOpen && stowagePlans && (
                            <DropDownOptionsList ref={masterPlanRef} width="400px" justify_content="left">
                                <li className="dd-heading" key="master-plan">
                                    Master Plan
                                </li>
                                <PageHeaderStowagePlanListItem stowagePlan={getMasterStowagePlan(stowagePlans)} onClick={switchStowagePlan} />
                                <li className="separator"></li>
                                <li className="dd-heading">Stowage plans</li>
                                <PageHeaderStowagePlanListGroup
                                    stowagePlans={getNonMastertowagePlans(stowagePlans, loggedInUser?.userName)}
                                    onClick={switchStowagePlan}
                                />
                            </DropDownOptionsList>
                        )}
                    </DropDownWrapper>
                    <DropdownIcon onClick={(e) => onOpenMasterPlanMenu(e)}>
                        <FontAwesomeIcon icon="chevron-down" />
                    </DropdownIcon>
                    <ExtraButtonMenu>
                        {hasPermission(role, stowageFeatureEnum.EditStowage) && <PageHeaderContextMenu />}
                        <MenuItemButton onClick={(e) => onOpenUtilization(e)} title="Open ship utilization">
                            <FontAwesomeIcon icon="scale-unbalanced-flip" />
                        </MenuItemButton>
                        <MenuItemButton onClick={(e) => onOpenPrintPanel(e)} title="Generate a report" className={isPrintPanelOpen ? 'selected' : ''}>
                            <FontAwesomeIcon icon="print" />
                        </MenuItemButton>

                        {hasPermission(role, stowageFeatureEnum.SynchronizeWithImos) && (
                            <MenuItemButton
                                className={triggerChangeLogProps?.isChangeLogOpen ? 'selected' : ''}
                                onClick={(e) => onOpenChangeLog(e)}
                                title="Synchronize with IMOS"
                            >
                                <FontAwesomeIcon icon="sync-alt" />
                                {numberOfOpenImosSyncChanges > 0 ? (
                                    <RedIcon className="red-icon" title={'Incoming changes from IMOS'}>
                                        {getValueOrMax(numberOfOpenImosSyncChanges)}
                                    </RedIcon>
                                ) : (
                                    <></>
                                )}
                            </MenuItemButton>
                        )}
                        <Separator />
                        <PageHeaderStowagePublishPromoteButton />

                        {shouldShowViolations() && (
                            <InvalidTankplan className="invalid text-overflow" type="invalid" onClick={(e) => onViewHardRuleViolations(e)}>
                                {shouldShowInvalidStowagePlan() && <span className="show-text">Invalid stowage plan</span>}
                                {hasHardRuleViolations() && (
                                    <IconsWrapper type="invalid">
                                        <ViolationListIconComponent
                                            violationType={StowageRuleConsequenceType.HardRule}
                                            includeText={false}
                                            count={violations.filter((o) => o.type === StowageRuleConsequenceType.HardRule).length}
                                        />
                                    </IconsWrapper>
                                )}
                                {hasSoftRuleViolations() && (
                                    <IconsWrapper type="warning">
                                        <ViolationListIconComponent
                                            violationType={StowageRuleConsequenceType.SoftRule}
                                            includeText={false}
                                            count={
                                                violations.filter(
                                                    (o) =>
                                                        o.type === StowageRuleConsequenceType.SoftRule &&
                                                        !(o.status === StowageRuleViolationStatus.Accepted)
                                                ).length
                                            }
                                        />
                                    </IconsWrapper>
                                )}
                            </InvalidTankplan>
                        )}
                    </ExtraButtonMenu>
                </StowageWrapper>
            </>
        )
    );
};

export default PageHeaderStowageComponent;
